<template>
	<div class="pipeline-search-filter-wrapper">
		<div class="pipeline-search-sort">
			<slot name="searchAndSort" />
		</div>
		<div class="pipeline-filter-stat">
			<div class="p-filters-wrapper">
				<slot name="filters" />
			</div>
			<div v-if="$slots['stats']" class="p-stats-wrapper">
				<PipelineFilterSeparator />
				<slot name="stats" />
			</div>
			<div v-if="$slots['actions']" class="p-actions-wrapper">
				<PipelineFilterSeparator />
				<slot name="actions" />
			</div>
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import PipelineFilterSeparator from "./PipelineFilterSeparator";

export default defineComponent({
	name: "PipelineSearchFilterWrapper",
	components: {
		PipelineFilterSeparator
	}
});
</script>
<style lang="scss">
.pipeline-search-filter-wrapper {
	display: flex;
	flex-direction: column;
	padding: 12px 0px 12px 0px;
	// max-width: 1500px;

	> .pipeline-search-sort {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
		padding: 12px 8px 12px 8px;
		grid-gap: 12px;
		align-items: center;
		max-width: 2000px;

		@media (max-width: 575px) {
			> * {
				grid-column: 1 / span 3;
			}
		}

		@media (min-width: 575px) {
			> .search-input-container {
				grid-column: 1 / span 4;
			}

			> * {
				grid-column: auto / span 2;
			}
		}

		@media (min-width: 768px) {
			> .search-input-container {
				grid-column: 1 / span 4;
			}

			> * {
				grid-column: auto / span 2;
			}
		}
		@media (min-width: 992px) {
			> .search-input-container {
				grid-column: 1 / span 4;
			}
			> * {
				grid-column: auto / span 1;
			}
		}
	}

	> .pipeline-filter-stat {
		display: flex;
		padding: 0px 8px 0px 8px;
		flex-wrap: wrap;
		align-items: center;

		div.pipeline-filter-separator {
			margin-left: 12px;
		}
		> * {
			margin: 12px 12px 12px 0px;

			&:first-child {
				margin: 0px 12px 0px 0px;
			}
		}

		> :last-child {
			margin: 12px 0px 12px 0px;
		}

		> .p-filters-wrapper {
			display: contents;
			align-items: center;
			flex-wrap: wrap;

			> * {
				margin: 12px 12px 12px 0px;
				width: 140px;
				min-width: 120px;
			}

			> :last-child {
				margin: 12px 0px 12px 0px;
			}
		}
		> .p-stats-wrapper {
			display: contents;
			align-items: center;

			> * {
				margin: 0px 12px 0px 0px;
			}

			> :last-child {
				margin: 0px 0px 0px 0px;
			}
		}
		> .p-actions-wrapper {
			display: contents;
			align-items: center;

			> * {
				margin: 0px 12px 0px 0px;
			}

			> :last-child {
				margin: 0px 0px 0px 0px;
			}
		}
	}
}
</style>
